<template>
  <div>
    <el-dialog
      :title="$t('添加标识符')"
      :visible.sync="visibleFlag"
      width="950px"
      @close="handleDialogShow"
      @closed="closed"
    >
      <div class="border" style="height:520px">
        <div class="d-flex border-bottom" style="height:40px">
          <div class="h4 border-right head"><span class="text">{{ $t('选择组') }}</span></div>
          <div class="h4 border-right head"><span class="text">{{ $t('选择Device') }}</span></div>
          <div class="h4 head d-flex justify-between">
            <span class="text">{{ $t('选择标识符') }}</span>
            <el-checkbox v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange" />
          </div>
        </div>
        <div class="d-flex" style="width:100%;height:480px">
          <!-- 组 -->
          <div class="border-right content">
            <el-scrollbar style="height:100%">
              <div v-for="(item,index) in groupList" :key="index">
                <div class="d-flex justify-between item-text" :class="selGroupId === item.id ? 'item-active': ''" @click="handleGroup(item.id)">
                  <span class="h4">{{ item.dataCollectGroupName }}</span>
                  <i class="fa fa-angle-right icon-right"></i>
                </div>
              </div>
            </el-scrollbar>
            <span v-if="groupList.length < 1" style="position: absolute;top: 350px;left: 145px;">{{ $t('暂无数据') }}</span>
          </div>
          <!-- 设备 -->
          <div class="border-right content">
            <el-scrollbar style="height:100%">
              <div v-for="(item,index) in deviceList" :key="index">
                <div class="d-flex justify-between item-text" :class="selDeviceId === item.id ? 'item-active': ''" @click="handleDevice(item.id)">
                  <span class="h4">{{ item.dataCollectDeviceName }}</span>
                  <i class="fa fa-angle-right icon-right"></i>
                </div>
              </div>
            </el-scrollbar>
            <span v-if="deviceList.length < 1" style="position: absolute;top: 350px;left: 450px;">{{ $t('暂无数据') }}</span>
          </div>
          <!-- 标识符 -->
          <div class="content identifier">
            <el-scrollbar style="height: 98%;">
              <div>
                <el-checkbox-group v-model="checkedIdentifier" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="(item, index) in identifierList" :key="index" :label="item.dataCollectTag">
                    <el-tooltip>
                      <div slot="content">
                        <span>{{ item.dataCollectTag }}({{ item.property }})</span>
                      </div>
                      <span class="text-ellipsis">{{ item.dataCollectTag }}({{ item.property }})</span>
                    </el-tooltip>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </el-scrollbar>
            <span v-if="identifierList.length < 1" style="position: absolute;top: 350px;left: 750px;">{{ $t('暂无数据') }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="identifierClose">{{ $t('取消') }}</el-button>
        <el-button v-preventReClick type="primary" @click="identifierSubmit">{{ $t('确定') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { datacollectApi } from '@klinx/base/src/api/index';

export default {
  name: 'Linkage',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    // 空间数据
    spaceData: {
      type: Array,
      default: () => []
    },
    // 设备数据
    deviceData: {
      type: Array,
      default: () => []
    },
    // 是否显示设备状态
    showStatus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visibleFlag: false,
      // 采集参数
      curPropertyRow: {},

      groupList: [],
      deviceList: [],
      identifierList: [],
      identifierOptions: [],
      selGroupId: '',
      selDeviceId: '',
      selIdentifierId: '',

      checkAll: false,
      isIndeterminate: false,
      checkedIdentifier: []
    };
  },
  watch: {
    visible() {
      this.visibleFlag = this.visible;
      this.getGroups();
    }
  },
  mounted() {
  },
  methods: {
    handleDialogShow() {
      this.$emit('update:visible', false);
    },
    closed() {
      this.$emit('closed');
    },
    // 获取组列表
    getGroups() {
      datacollectApi.getAllGroupList().then(response => {
        const res = response.data;
        if (res.isSuccess) {
          this.groupList = res.data;
          this.deviceList = [];
          this.identifierList = [];
          this.identifierOptions = [];
          this.selGroupId = '';
          this.selDeviceId = '';
          this.selIdentifierId = '';
          this.checkAll = false;
          this.isIndeterminate = false;
          this.checkedIdentifier = [];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 点击组
    handleGroup(Id) {
      this.selGroupId = Id;
      this.checkedIdentifier = [];
      this.isIndeterminate = false;
      this.identifierList = [];
      this.identifierOptions = [];
      this.getDevices(Id);
    },
    // 获取设备列表
    getDevices(groupId) {
      datacollectApi.getDeviceList(groupId).then(response => {
        const res = response.data;
        if (res.isSuccess) {
          this.deviceList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 点击设备
    handleDevice(Id) {
      this.selDeviceId = Id;
      this.checkedIdentifier = [];
      this.identifierOptions = [];
      this.isIndeterminate = false;
      this.getIdentifiers(Id);
    },
    // 获取标识符列表
    getIdentifiers(deviceId) {
      datacollectApi.getIdentifierList(deviceId).then(response => {
        const res = response.data;
        if (res.isSuccess) {
          this.identifierList = res.data;
          this.$emit('identifierList', this.identifierList);
          res.data.forEach(item => {
            this.identifierOptions.push(item.dataCollectTag);
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 点击标识符
    handleCheckAllChange(val) {
      this.checkedIdentifier = val ? this.identifierOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      this.checkedIdentifier = value;
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.identifierList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.identifierList.length;
    },
    // 取消、提交
    identifierClose() {
      this.groupList = [];
      this.deviceList = [];
      this.selGroupId = '';
      this.selDeviceId = '';
      this.selIdentifierId = '';

      this.identifierList = [];
      this.identifierOptions = [];
      this.isIndeterminate = false;
      this.checkedIdentifier = [];
      this.visibleFlag = false;
    },
    identifierSubmit() {
      this.$emit('checked', this.checkedIdentifier);
    }
  }
};
</script>

<style lang='scss' scoped>
//添加标识符
.head {
  width: 33%;
  line-height: 40px;
  .text {
    font-weight: 600;
    padding-left: 15px;
  }
  .el-checkbox{
    margin-right: 4px;
  }
}
.content {
  width: 33%;
  .item-text{
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    .icon-right{
      line-height: 40px;
    }
    &:hover{
      background: #fff0e6;
      cursor: pointer;
    }
  }
  .item-active{
    background: #fff0e6;
  }
}
.identifier{
  ::v-deep {
    .el-scrollbar__thumb {
      display: none;
    }
    .el-checkbox__label{
      white-space:nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 250px;
    }
    .el-scrollbar__wrap{
      overflow-x: hidden;
      overflow-y: auto;
    }
    .el-checkbox-group{
      display: grid;
      // width: 98%;
    }
    .el-checkbox{
      height: 40px;
      line-height: 40px;
    }
    .el-checkbox__input{
      position: absolute;
      left: 284px;
      line-height: 40px;
    }
  }
}
</style>
